<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	//Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import { Text, Input, IconButton, Container, Modal, Button } from '@Shelly/shelly-design-system';
	//Helpers
	import { isValidURL } from 'src/helpers/utilities';
	import { copy } from 'src/helpers/copy_text';
	//Components
	import Tokens from './Tokens.svelte';
	//Types
	import type { WebhookURLError } from 'src/helpers/actions/webhooks/core/webhook_url_action_helpers';

	export let editUrlValue: string, showModal: boolean, tokens: string[], error: WebhookURLError;

	const dispatcher = createEventDispatcher();
	const onSaveEditUrl = () => {
		isEditUrlValid = isValidURL(editUrlValue, true);
		if (isEditUrlValid) {
			dispatcher('edit', editUrlValue);
			onCloseEditUrlModal();
		}
	};

	const onCloseEditUrlModal = () => {
		editUrlValue = '';
		isEditUrlValid = true;
		showModal = false;
	};

	const onFocusInputField = (target: EventTarget): void => {
		selectedInputField = target as HTMLInputElement;
	};

	let isEditUrlValid = true;
	let selectedInputField: HTMLInputElement;
</script>

<Modal
	title={$format('edit_url', {
		default: 'Edit URL',
	})}
	{showModal}
	on:close={onCloseEditUrlModal}
	removeScrollPadding
>
	<Container slot="content" padding="scrollPaddings">
		<Text class="mb-s" styleType="h2">
			{$format('url_action', { default: 'URL Action' })}
		</Text>
		<div class="d-flex pb-s">
			<Input
				aria-labelledby="input-in5i43l"
				class="mr-s"
				bind:value={editUrlValue}
				type="text"
				size="m"
				icon="fas fa-link"
				label={$format('input_label_enter_url_link', {
					default: 'Enter a URL link',
				})}
				tabIndex="-1"
				error={isEditUrlValid
					? ''
					: $format('enter_valid_url', {
							default: 'Invalid URLs: Please enter a valid URL!',
						})}
				on:focus={(e) => {
					onFocusInputField(e.target);
					isEditUrlValid = true;
				}}
				on:blur={(e) => {
					if (e.relatedTarget?.['className']?.includes('modal-close-btn')) return;
					if (!e.relatedTarget?.['className']?.includes('token-btn')) {
						onFocusInputField(null);
					}
					isEditUrlValid = isValidURL(editUrlValue, true);
				}}
				on:input={(e) => {
					error.show = false;
					onFocusInputField(e.target);
				}}
				id="input-in5i43l"
			/>
			<IconButton
				aria-label={$format('button_copy_url', {
					default: 'Button copy url',
				})}
				icon="fas fa-copy"
				variant="primary"
				on:click={() => {
					copy(
						editUrlValue,
						$format('copied_successfully', {
							default: 'Copied successfully!',
						}),
					);
				}}
			/>
		</div>
		{#if tokens != null}
			<div class="d-flex flex-direction-column align-items-start">
				<Tokens {tokens} {selectedInputField} />
			</div>
		{/if}
	</Container>

	<div slot="footer" class="d-flex justify-content-end">
		<Button
			class="width-md-m width-sm-full mr-s modal-close-btn"
			responsiveSize={{
				sm: 'm',
			}}
			variant="secondary"
			on:click={onCloseEditUrlModal}
		>
			{$format('cancel', { default: 'Cancel' })}
		</Button>
		<Button
			class="width-md-m width-sm-full"
			responsiveSize={{
				sm: 'm',
			}}
			on:click={onSaveEditUrl}
		>
			{$format('button_save', { default: 'Save' })}
		</Button>
	</div>
</Modal>
